import { render, staticRenderFns } from "./LocomotiveCrewWorkAnalytics.vue?vue&type=template&id=63d7396c&scoped=true&"
import script from "./LocomotiveCrewWorkAnalytics.vue?vue&type=script&lang=ts&"
export * from "./LocomotiveCrewWorkAnalytics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d7396c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
